export default __webpack_public_path__ + "static/media/icon-minus-red.e0c3ad0b.svg";